const DEFAULT_TIMEOUT = 4000

const CART_SELECTOR = '#CartPopup'

class CartAnnouncements extends HTMLElement {
  #announcementEl
  #timeout

  constructor() {
    super()

    this.#announcementEl = this.querySelector('div')
    this.announceCartUpdate = this.announceCartUpdate.bind(this)
    this.handleCartAdd = this.handleCartAdd.bind(this)
    this.handleCartUpdate = this.handleCartUpdate.bind(this)
  }

  announceCartUpdate(msg) {
    if (this.#timeout) clearTimeout(this.#timeout)

    this.#announcementEl.innerHTML = msg

    this.#timeout = setTimeout(() => {
      this.#announcementEl.innerHTML = ''
    }, DEFAULT_TIMEOUT)
  }

  handleCartAdd(e) {
    const cart = e.detail.cart

    // Handle direct items array (from cart add response)

    if (cart?.items && Array.isArray(cart.items)) {
      const items = cart.items

      if (items.length === 1) {
        const item = items[0]

        const productName = item.product_title || item.title || 'Product'

        this.announceCartUpdate(`${productName} added to cart`)
      } else {
        this.announceCartUpdate(`${items.length} items added to cart`)
      }

      return
    }

    // Handle single item objects (legacy format)

    if (cart?.product_title || cart?.title) {
      const productName = cart.product_title || cart.title || 'Product'

      this.announceCartUpdate(`${productName} added to cart`)

      return
    }

    // Fallback announcement

    this.announceCartUpdate('Item added to cart')
  }

  handleCartUpdate(e) {
    const cart = e.detail.cart

    if (cart && cart.item_count !== undefined) {
      const itemCount = cart.item_count

      if (itemCount === 0) {
        this.announceCartUpdate('Cart is now empty')
      } else {
        this.announceCartUpdate(`Cart updated. ${itemCount} item${itemCount !== 1 ? 's' : ''} in cart`)
      }
    }
  }

  connectedCallback() {
    document.addEventListener('on:cart:add', this.handleCartAdd)

    document.addEventListener('on:cart:update', this.handleCartUpdate)
  }

  disconnectedCallback() {
    document.removeEventListener('cart:add', this.handleCartAdd)

    document.removeEventListener('cart:update', this.handleCartUpdate)

    if (this.#timeout) clearTimeout(this.#timeout)
  }
}

customElements.define('cart-announcements', CartAnnouncements)

function waitForEl(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

// ------------TD CHANGE-----------
waitForEl(CART_SELECTOR).then(el => el.insertAdjacentHTML('afterbegin', '<cart-announcements class="patrol-sr-only"><div id="cart-info" role="status" aria-live="polite" aria-atomic="true"></div></cart-announcements>'))
// ----------END TD CHANGE---------

;(function () {
  function waitForEl(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector))
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          observer.disconnect()
          resolve(document.querySelector(selector))
        }
      })

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })
  }

  waitForEl('#CartPopup').then(function () {
    const cartEl = document.querySelector('#CartPopup')
    const cartItemsList = cartEl.querySelector('.upcart-products-section')

    const handleMutations = mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          makeRemovalButtonsAccessible(mutation)
        }
      }
    }

    const mutationObserver = new MutationObserver(handleMutations)

    mutationObserver.observe(cartItemsList, { childList: true })

    function makeRemovalButtonsAccessible() {
      cartItemsList.querySelectorAll('[class*="deleteButton"]').forEach(function (deleteButton) {
        if (!deleteButton.parentElement.querySelector('button.patrol-sr-only')) {
          let buttonA11y = document.createElement('button').cloneNode(false)
          buttonA11y.classList.add('patrol-sr-only')
          buttonA11y.setAttribute('aria-label', 'Remove Item from Cart')
          buttonA11y.addEventListener('click', function () {
            deleteButton.click()
          })
          deleteButton.insertAdjacentElement('afterend', buttonA11y)
        }
      })
    }
    makeRemovalButtonsAccessible()
  })
})()

function addAriaLabel() {
    // Select any button with the target class
    const button = document.querySelector('button.corso-info-icon');
    if (button && !button.hasAttribute('aria-label')) {
      button.setAttribute('aria-label', 'more information about shipping');
      console.log('aria-label added to shipping info button');
      return true;
    }
    return false;
  }

  // Try immediately in case it's already in the DOM
  if (!addAriaLabel()) {
    const observer = new MutationObserver((mutations, obs) => {
      if (addAriaLabel()) {
        obs.disconnect(); // stop once done
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

